module.exports = __webpack_public_path__ + "static/img/bg-id.1a726fe6.webp";